import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Row } from 'grab-ui';
import {
  LIMIT_ITEMS,
  TRIDENT_CAMPAIGN_TEMPLATE as CAMPAIGN_TEMPLATE,
  TRIDENT_CAMPAIGN_TEMPLATE,
} from 'omega-rtc/constants/ucd';

import './CreateTridentCampaign.scss';

import _ from 'lodash';
import { getRequestStateKey } from 'omega-rtc/utils/ucd-utils';
import { GET_UCD_CAMPAIGN, getUCDCampaign } from 'omega-rtc/actions/ucd';
import CreateCampaignProgressPanel from 'omega-rtc/views/ucd/trident/CreateCampaignProgressPanel';
import TemplateSelectionPage from 'omega-rtc/views/ucd/trident/pages/TemplateSelectionPage';
import SchedulePage from 'omega-rtc/views/ucd/trident/pages/SchedulePage';
import { Button, Dimmer, Loader } from 'semantic-grab-ui';
import ScenarioPage from 'omega-rtc/views/ucd/trident/pages/ScenarioPage';
import EnumerationActionPage from 'omega-rtc/views/ucd/trident/pages/EnumerationActionPage';
import { tridentUserVsUCDUser } from 'data/trident-campaigns';
import { TridentCampaignFormData } from 'omega-rtc/types/ucd/campaign';
import Toastr from 'omega-rtc/utils/toastr-util';
import { isFieldModified } from 'omega-rtc/utils/simple-scenario-utils';
import { getListRuleTypes } from 'omega-rtc/actions/newTridentExtra';
import JourneyPage from 'omega-rtc/views/ucd/trident/pages/JourneyPage';


type Props = {
  // From redux
  getCampaign: Function,
  projectID: string,
  listRuleTypes: any,
  countries: any,
  user: any,
  userPermissions: any,
  campaignView: any,
  getCampaignRequest: Function,
  createTridentCampaignRequest: Function,

  // From Parent Component
  formData: TridentCampaignFormData,
  currentPageIndex: number,
  handleSubmitForm: Function,
  isEditPage: boolean
};


class TridentCampaignPage extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.validateForm = () => {
    }; // To be overriden by child component

    this.state = {
      totalSection: 3, // Total section based on selected template type to determine "Next" or "Submit button. Set initial higher than 1
      formData: this.props.formData,
      currentPageIndex: this.props.currentPageIndex || 1,
      error: {
        ownerErrors: [],
        conditionErrors: [],
        actionErrors: {}, // Action has hashmap structure
        limitErrors: [],
      },
    };

    const { getCampaign, projectID, campaignID } = this.props;
    getCampaign(projectID, campaignID);
  }

  handleSectionSelected = (pageIndex) => {
    if (!this.isAllowedToNextPage(pageIndex)) {
      return;
    }
    this.setState({ currentPageIndex: pageIndex });
  };

  handleTemplateSelection = (templateType) => {
    const { formData } = this.state;
    _.set(formData, 'templateType', templateType);
    this.setState({ formData, error: null });
  };

  handleSubmitForm = () => {
    const error = this.validateForm();
    if (!_.isEmpty(error.ownerErrors) || !_.isEmpty(error.conditionErrors) ||
      !_.isEmpty(error.actionErrors) || !_.isEmpty(error.limitErrors)) {
      Toastr.error('There are errors in the form');
      this.setState({ error });
      return;
    }
    const formData = _.cloneDeep(this.state.formData);

    // Convert limit fields value to integer
    _.forEach(LIMIT_ITEMS, limitItem => {
      const limitInt = parseInt(_.get(formData, limitItem.inputKey, 0), 10);
      _.set(formData, limitItem.inputKey, limitInt);
    });

    this.props.handleSubmitForm(formData);
  };

  isAllowedToSubmitForm = (formData: TridentCampaignFormData) => {
    const templateType = _.get(formData, 'templateType');
    if (_.isEmpty(templateType)) {
      return false;
    }
    const templateRequireFields = {
      [TRIDENT_CAMPAIGN_TEMPLATE.simpleScenario]: ['owner', 'eventType', 'actions', 'limit'],
      [TRIDENT_CAMPAIGN_TEMPLATE.simpleSchedule]: ['owner', 'scheduleTime', 'segmentName', 'actions'],
    };

    return this.notAllowedEmptyOnFields(_.get(templateRequireFields, templateType, []), formData);
  };

  notAllowedEmptyOnFields = (fields: Array<String>, formData: TridentCampaignFormData) => {
    let isAllowed = true;
    fields.forEach(field => {
      if (_.isEmpty(_.get(formData, field))) {
        isAllowed = false;
        return false; // break the loop
      }
    });
    return isAllowed;
  };

  isAllowedToGoNextPage = (formData: TridentCampaignFormData) => {
    switch (this.state.currentPageIndex) {
      case 2:
      {
        const templateType = _.get(formData, 'templateType');
        const templateRequireFields = {
          [TRIDENT_CAMPAIGN_TEMPLATE.simpleScenario]: [],
          [TRIDENT_CAMPAIGN_TEMPLATE.simpleSchedule]: ['owner', 'segmentName', 'actions'],
        };

        return this.notAllowedEmptyOnFields(_.get(templateRequireFields, templateType, []), formData);
      }
      default:
        return true;
    }
  };

  onNextPageClick = (templateType: string, currentPageIndex: number, redirectToTridentURL: string) => {
    if (!this.isAllowedToNextPage(currentPageIndex + 1)) {
      return;
    }

    const isInJourneyCustomisationStep = templateType === TRIDENT_CAMPAIGN_TEMPLATE.multistepJourney && currentPageIndex === 2;
    if (templateType === TRIDENT_CAMPAIGN_TEMPLATE.fromBlank || isInJourneyCustomisationStep) {
      location.href = redirectToTridentURL;
    } else {
      this.handleSectionSelected(currentPageIndex + 1);
    }
  };

  isAllowedToNextPage = (nextPageIndex: number): boolean => {
    // validate before allowing to switch page.
    const templateType = _.get(this.state.formData, 'templateType', '');
    const currentPageIndex = this.state.currentPageIndex;

    switch (templateType) {
      case TRIDENT_CAMPAIGN_TEMPLATE.simpleSchedule:

        if (currentPageIndex < nextPageIndex) {
          const error = this.validateForm();
          if (_.isEmpty(error)) {
            break;
          }
          if (
            !_.isEmpty(error.ownerErrors)
            || !_.isEmpty(error.actionErrors)
            || !_.isEmpty(error.segmentErrors)
          ) {
            Toastr.error('There are errors in the form');
            this.setState({ error });
            return false;
          }
        }
        break;

      default:
        break;
    }

    return true;
  };


  getErrorFieldsToUpdate = (prevFormData: TridentCampaignFormData, updatedFormData: TridentCampaignFormData) => {
    const emptyErrorFields = {};

    if (isFieldModified(prevFormData, updatedFormData, 'owner') ||
      isFieldModified(prevFormData, updatedFormData, 'ownerReferenceID')) {
      _.set(emptyErrorFields, 'ownerErrors', []);
    }

    if (isFieldModified(prevFormData, updatedFormData, 'actions')) {
      _.set(emptyErrorFields, 'actionErrors', {});
    }

    switch (_.get(updatedFormData, 'templateType')) {
      case TRIDENT_CAMPAIGN_TEMPLATE.simpleScenario:
        if (isFieldModified(prevFormData, updatedFormData, 'mandatoryCondition')) {
          _.set(emptyErrorFields, 'conditionErrors', []);
        }

        if (isFieldModified(prevFormData, updatedFormData, 'limit')) {
          _.set(emptyErrorFields, 'limitErrors', []);
        }
        break;
      default:
        break;
    }
    return emptyErrorFields;
  };

  handleFormDataChange = (updatedFormData: Object) => {
    this.setState(prevState => {
      const prevFormData = _.get(prevState, 'formData');
      if (isFieldModified(prevFormData, updatedFormData, 'owner')) {
        _.set(updatedFormData, 'eventType', '');
        _.set(updatedFormData, 'ownerReferenceID', '');
        _.set(updatedFormData, 'mandatoryCondition', {});
        _.set(updatedFormData, 'condition', {});
        _.set(updatedFormData, 'actions', []);
      }

      if (isFieldModified(prevFormData, updatedFormData, 'eventType')) {
        _.set(updatedFormData, 'condition', {});
        _.set(updatedFormData, 'actions', []);
      }

      // Clear the error messages when the value is changed
      const updatedErrorFields = this.getErrorFieldsToUpdate(prevFormData, updatedFormData);

      return {
        formData: { ...prevState.formData, ...updatedFormData },
        error: { ...prevState.error, ...updatedErrorFields },
      };
    });
  };

  handleJourneyTemplateSelection = (journeyTemplateKey) => {
    this.setState({
      journeyTemplateKey,
    });
  }

  // return format: {countryID: 4, cities: Array(1459), currency: 'SGD', code: 'SG', name: 'Singapore'}
  getCountry(countryID) {
    return _.find(this.props.countries, { countryID });
  }

  getSection(pageIndex: number, templateType: string, listRuleTypes: any, targetUserType: string, isEditPage: boolean) {
    const { campaignID, projectID } = this.props;
    const { formData, error } = this.state;
    const campaignView = _.get(this.props, 'campaignView', {});
    const countryID = _.get(campaignView, 'countryID', 0);
    const campaign = _.get(campaignView, 'campaign', {});

    // Sections
    const templateSelectionPage = (<TemplateSelectionPage
      templateType={templateType}
      onTemplateSelected={this.handleTemplateSelection}
      validateFormRef={validateSelectionForm => this.validateForm = validateSelectionForm}
      blankURL={this.constructRedirectToTridentURL(projectID, campaignID, 'from-blank')}
    />);

    const scenarioPage = (<ScenarioPage
      country={this.getCountry(countryID)}
      formData={formData}
      targetUserType={targetUserType}
      campaign={campaign}
      isEditPage={isEditPage}
      listRuleTypes={listRuleTypes}
      handleFormDataChange={this.handleFormDataChange}
      validateFormRef={validateScenarioForm => this.validateForm = validateScenarioForm}
      error={error}
    />);

    const journeyPage = (<JourneyPage
      country={this.getCountry(countryID)}
      formData={formData}
      targetUserType={targetUserType}
      campaign={campaign}
      isEditPage={isEditPage}
      listRuleTypes={listRuleTypes}
      handleFormDataChange={this.handleFormDataChange}
      handleTemplateChange={this.handleJourneyTemplateSelection}
      validateFormRef={validateScenarioForm => this.validateForm = validateScenarioForm}
      error={error}
    />);

    const enumartionActionPage = (<EnumerationActionPage
      country={this.getCountry(countryID)}
      targetUserType={targetUserType}
      campaign={campaign}
      countries={this.props.countries}
      formData={formData}
      handleFormDataChange={this.handleFormDataChange}
      validateFormRef={validateEnumerationForm => this.validateForm = validateEnumerationForm}
      error={error}
    />);

    const schedulePage = (<SchedulePage
      country={this.getCountry(countryID)}
      targetUserType={targetUserType}
      campaign={campaign}
      countries={this.props.countries}
      formData={formData}
      handleFormDataChange={this.handleFormDataChange}
      validateFormRef={validateScheduleForm => this.validateForm = validateScheduleForm}
      error={error}
    />);

    // Pages flow
    const simpleSchedulePages = [templateSelectionPage, enumartionActionPage, schedulePage]; // 1. TemplateSelectionPage -> 2.EnumerationActionPage -> 3. SchedulePage
    const simpleScenarioPages = [templateSelectionPage, scenarioPage];
    const simpleJourneyPages = [templateSelectionPage, journeyPage];

    if (templateType === TRIDENT_CAMPAIGN_TEMPLATE.simpleScenario) {
      return simpleScenarioPages[pageIndex - 1]; // pageIndex is started from 1. hence need to -1
    } else if (templateType === TRIDENT_CAMPAIGN_TEMPLATE.simpleSchedule) {
      return simpleSchedulePages[pageIndex - 1];
    } else if (templateType === TRIDENT_CAMPAIGN_TEMPLATE.multistepJourney) {
      return simpleJourneyPages[pageIndex - 1];
    }
    return templateSelectionPage; // Default page
  }

  constructRedirectToTridentURL(projectID, campaignID, templateType) {
    if (templateType === TRIDENT_CAMPAIGN_TEMPLATE.multistepJourney) {
      const { journeyTemplateKey } = this.state;
      return `${location.origin}/ucd/project/${projectID}/journey_campaign/${campaignID}/create/${journeyTemplateKey}`;
    }

    return `${window.Grab.config.OMEGA_RTC_URI}/campaigns/new?ucdProjectID=${projectID}&ucdCampaignID=${campaignID}`;
  }

  render() {
    const campaignView = _.get(this.props, 'campaignView', {});
    if (_.isEmpty(campaignView)) {
      return <Dimmer inverted active> <Loader /> </Dimmer>;
    }

    const listRuleTypes = _.get(this.props, 'listRuleTypes', {});
    const audience = _.get(campaignView, 'audience', '');
    const targetUserType = Object.keys(tridentUserVsUCDUser).find(key => tridentUserVsUCDUser[key] === audience);

    const { formData, currentPageIndex } = this.state;
    const templateType = _.get(formData, 'templateType', '');
    const { campaignID, projectID, isEditPage } = this.props;
    const redirectToTridentURL = this.constructRedirectToTridentURL(projectID, campaignID, templateType);

    const isLastSection = (templateType === CAMPAIGN_TEMPLATE.simpleSchedule && currentPageIndex === 3)
      || (templateType === CAMPAIGN_TEMPLATE.simpleScenario && currentPageIndex === 2);

    return (
      <Row gutter={24} className={'create-template-container'}>
        <Col sm={16} className={'col-template'}>
          <React.Fragment>
            {this.getSection(currentPageIndex, templateType, listRuleTypes, targetUserType, isEditPage)}

            {!_.isEmpty(templateType) &&
              <div className={'form-action-button'}>
                {isLastSection
                  ? <Button
                    onClick={this.handleSubmitForm}
                    disabled={!this.isAllowedToSubmitForm(formData)}
                  > {isEditPage ? 'Update' : 'Create'} </Button>
                  : <Button
                    onClick={() => {
                      this.onNextPageClick(templateType, currentPageIndex, redirectToTridentURL);
                    }}
                    disabled={!this.isAllowedToGoNextPage(formData)}
                  > Next </Button>
                }


              </div>
            }
          </React.Fragment>
        </Col>
        <Col sm={8} style={{ paddingLeft: '42px' }}>
          <h3>Guided Campaign Setup </h3>
          <p>Follow these steps and track your campaign creation progress</p>
          <CreateCampaignProgressPanel
            onSectionSelected={this.handleSectionSelected}
            formData={formData}
            activeIndex={currentPageIndex}
            listRuleTypes={listRuleTypes}
            targetUserType={targetUserType}
          />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state: StoreState, ownProps: Object) => {
  const userPermissions = state.app.user.userPermissions;
  const countries = state.countries.entities;
  return {
    projectID: ownProps.params.entityID,
    campaignID: ownProps.params.campaignID,
    listRuleTypes: state.ucd.listRuleTypes,
    countries,
    user: state.app.user,
    userPermissions,
    campaignView: state.ucd.campaignView,
    getCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(GET_UCD_CAMPAIGN),
      {},
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getCampaign: (projectID, campaignID) => {
    dispatch(getUCDCampaign(projectID, campaignID));
  },
  getListRuleTypes: (owner, targetUserType) => {
    dispatch(getListRuleTypes({ owner, targetUserType }));
  },
});


const FormHOC = Form.create();
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormHOC(TridentCampaignPage));
